import { api } from '@/apis';
import { log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useObjective(id) {
  const queryKey = ['objectives', id];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const json = [
        { $match: { identifier: id } },
        {
          $project: {
            identifier: true,
            title: true,
            contentHTML: true,
            startTime: true,
            endTime: true,
            complianceSeconds: true,
            requiredVisits: true,
            requiredFrequency: true,
            boundaryType: true,
            boundarySubtype: true,
            boundaryIdentifier: true,
            boundary: true,
            created: true,
            lastEdit: true,
            occurrenceNumber: true,
            schedule: true,
            applicableTo: true,
            visibleTo: true,
            notifications: true,
            microbeats: true,
            resourceType: true,
            personCodes: true,
            vehicleIdentificationNumbers: true,
            personGroupCodes: true,
            vehicleGroupCodes: true,
          },
        },
      ];

      const objectives = await api
        .post('pipeline/objectives', { json, signal })
        .json();

      log('Read', 'Objectives', { id });

      return objectives[0] ?? null;
    },
    staleTime: 1000 * 60 * 60,
    enabled: !!id,
  });

  return {
    ...query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
